export const ENROLLMENT_YEAR_LIST = ["2023", "2024"];

export const VEB_BILLING_YEAR_LIST = ["2023", "2024", "2025"];

export const VEB_BILLING_REPORT_MONTH = [
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December"
];
